export const PENDING_APPROVAL_TAB_KEY = 'pendingApproval';

export const createPendingApprovalTabConfig = () => ({
	key: PENDING_APPROVAL_TAB_KEY,
	label: 'Pending Approval',
	search: {
		mode: 'server',
		placeholder: 'Name or email',
		debounceMs: 400,
		minChars: 1,
	},
	emptyStateLabel: 'pending users',
	getData: () => [],
	filterPrincipal: () => true,
	getPrincipalId: (principal) => principal.id || principal.email,
	getPrincipalPrimaryText: (principal) => principal.name || principal.email,
	getPrincipalSecondaryText: (principal) => principal.email,
	mapItem: (item) => ({
		...item,
		id: item.email || item.id,
		name: `${item.firstName || ''} ${item.lastName || ''}`.trim() || item.email,
	}),
	scopes: [],
});
